import React, { useEffect } from 'react';
import { Image } from './image';
import { List } from './list';
import TagManager from 'react-gtm-module';

import './simple-track.scss';

const SimpleTrack = ({ config }) => {

  useEffect(() => {
    const dataLayerArgs = {
      dataLayer: {
        event: 'rbVideoTracking',
        eventCategory: 'video',
        eventAction: 'sidebar',
        eventLabel: 'loaded',
        widgetType: `Track - ${config.trackingTitle || config.navigationTitle}`
      }
    };

    TagManager.dataLayer(dataLayerArgs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="appRow simpleTrack">
      {config.image && (
        <div className="appRow full-width">
          <Image src={config.image} alt={config.headline || config.image} />
        </div>
      )}
      {config.headline && config.headline.length && (
        <h3 className="h3">{config.headline}</h3>
      )}
      {config.lists &&
        config.lists.map((list, index) => <List key={`STList-${index}`} data={list} />)}
    </div>
  );
};

export { SimpleTrack };
